<template>
    <div>
        <p class="is-italic has-text-info clarity-mask">
            {{
                translate("audit_logs.template.eventRegistrationUpdate", false, [
                    context.eventRegistrationId,
                    context.firstName,
                    context.lastName,
                    context.academyName,
                ])
            }}
        </p>
        <p>
            {{ translate("common.category") }}: {{ context.categoryName }}, {{ translate("audit_logs.action") }}:
            <span class="has-text-weight-bold">{{ context.action }}</span>
        </p>
    </div>
</template>

<script setup lang="ts">
    import { EventRegistrationUpdate } from "../../Api/auditLogsApi";
    import { translate } from "../../Common/translations";
    import { User } from "../../Common/types";

    defineProps<{
        context: EventRegistrationUpdate;
        user: User;
    }>();
</script>

<style scoped></style>
